import { isMobile, isTablet } from './device'



export const getJumpPath = (curName, allJumpPaths) => {
	// 当前归类：平板竖屏，横屏均为 h5 
	if (isMobile() || isTablet()) {
		if (allJumpPaths.get(curName)[1] === 'pc') {
			return allJumpPaths.get(curName)[0];
		}
	} else {
		if (allJumpPaths.get(curName)[1] === 'h5') {
			return allJumpPaths.get(curName)[0];
		}
	}
}